import { Injectable } from '@angular/core';
declare let ga: Function; // Declare ga as a function
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  public addEvent(category: string,
    action: string,
    label: string = null,
    value: number = null) {
    if (typeof (ga) != 'undefined') {
      ga('send', 'event', {
        eventCategory: category,
        eventLabel: label,
        eventAction: action,
        eventValue: value
      });
    }
  }

  public addError(exceptionDescription: string,
    isExceptionFatal: boolean) {
    if (typeof (ga) != 'undefined') {
      ga('send', 'exception', {
        'exDescription': exceptionDescription,
        'exFatal': isExceptionFatal
      });
    }
  }
}
